const TextPage = ({children}) => {
    return (
        <div
            className="
        my-8
        mx-auto
        w-[90%]
        max-w-4xl
        bg-[#1A1C2D]
        rounded-[16px]
        text-paragraph
        px-4
        py-8
      "
        >
            {children}
        </div>
    );
};

export default TextPage;
